import { allowPlainObjectJsonMapper } from '../data/json-mapper.js'
import { TRPCLink } from '@trpc/client'
import { observable } from '@trpc/server/observable'
export function createJsonResponseLinkMapper(): TRPCLink<any> {
	return () => {
		return ({ next, op }) => {
			return observable((observer) => {
				if (op.input && typeof op.input == 'object') {
					op.input = allowPlainObjectJsonMapper.serializeToObject(op.input)
				}

				const subscription = next(op).subscribe({
					next(envelope) {
						if (envelope.result.type == 'data') {
							const mapped = allowPlainObjectJsonMapper.deserializeFromObject(
								envelope.result.data as object,
							)

							const newEnvelope = {
								...envelope,
								result: {
									...envelope.result,
									data: mapped,
								},
							}

							observer.next(newEnvelope)
						} else {
							observer.next(envelope)
						}
					},
					error(err) {
						observer.error(err)
					},
					complete() {
						observer.complete()
					},
				})

				return subscription
			})
		}
	}
}
